import { NEW_ADD_OR_CANCEL, SET_EDIT_INFO, SET_PAGE, RESET_STATE, SET_TYPECODE, SET_RADIOTYPECODE } from './actionTypes'

const initialState = {
    showPage: 1,
    editInfo: '',
    isEdit: false,
    radioTypeCode: '1',
    tableParams:{
        pageCount: 1,
        pageSize: 10,
        taskName:''
    }
}

export default (state = initialState, { type, payload }) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (type) {

        case NEW_ADD_OR_CANCEL: {
            const { showPage } = payload
            newState.showPage = showPage
            newState.isEdit = false
            break;
        }
        case SET_EDIT_INFO: {
            const { info } = payload
            newState.isEdit = true
            newState.editInfo = Object.assign({}, info)
            break;
        }
        case SET_PAGE: {
            const { data } = payload
            newState.tableParams ={...newState.tableParams,...data}
            break;
        }
        case SET_TYPECODE: {
            const { value } = payload
            newState.typeCode = value
            break;
        }
        case SET_RADIOTYPECODE: {
            const { value } = payload
            newState.radioTypeCode = value
            break;
        }
        case RESET_STATE: {
            newState = initialState
            break;
        }

    }
    return newState
}
